import { render, staticRenderFns } from "./CampaignDetailsPreview.vue?vue&type=template&id=b0b8a432&scoped=true"
import script from "./CampaignDetailsPreview.vue?vue&type=script&lang=js"
export * from "./CampaignDetailsPreview.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailsPreview.vue?vue&type=style&index=0&id=b0b8a432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b8a432",
  null
  
)

export default component.exports